import { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { AuthContext } from "../context/AuthContext";
import { saveInviteCode } from "../lib/referralInvite";

// requesta.app/join/CODE — a talent's Refer & Earn link. Remembers the code on
// this device and hands straight off: the app opens its welcome tour, the web
// goes to signup. Signup shows "Invited by …" and sends the code along. A code
// that turns out not to exist is simply ignored there — this page never errors.
// Someone already signed in (a talent tapping a friend's link) just goes home:
// an invite is for new accounts only.
export default function JoinPage() {
  const { code } = useParams<{ code: string }>();
  const { isAuthenticated, loading } = useContext(AuthContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) return;
    if (isAuthenticated) {
      navigate("/", { replace: true });
      return;
    }
    if (code) saveInviteCode(code);
    navigate(Capacitor.isNativePlatform() ? "/welcome" : "/register", { replace: true });
  }, [code, isAuthenticated, loading, navigate]);
  return null;
}
